module.exports = __webpack_public_path__ + "media/images/vector/FacebookLogo-f27d0ff56d196467e9caa4e425b60dab.svg";